import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class PersonalProfile extends Component {


    render(){
      return(

        <section className="slice-sm sct-color-1">
                   <div className="profile">
                       <div className="container">
                           <div className="row cols-xs-space cols-sm-space cols-md-space">
                               <div className="col-lg-3">
                                   <table className="table profile-table">
                                      <tr>
                                          <td> <a>Personal Profile</a> </td>
                                      </tr>
                                      <tr>
                                          <td> <a>Personal Profile</a> </td>
                                      </tr>
                                      <tr>
                                          <td> <a>Personal Profile</a> </td>
                                      </tr>
                                      <tr>
                                          <td> <a>Personal Profile</a> </td>
                                      </tr>
                                   </table>
                               </div>

                               <div className="col-lg-9">
                                   <div className="main-content">


                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
        </section>

      );
    }

}



// WEBPACK FOOTER //
// ./src/containers/PersonalProfile.js